import {
  ContactPreferenceOptions,
  ContactPreferences,
  UnsubscribeWithEncryptedTopicResponseBody
} from "@seneca/notifications-service-types";
import { useEffect, useState } from "react";

export function useContactPreferencesState(
  initialPreferences: UnsubscribeWithEncryptedTopicResponseBody | undefined,
  hasLoaded: boolean
) {
  const [preferences, setPreferences] = useState(initialPreferences);

  useEffect(() => {
    if (hasLoaded) {
      setPreferences(initialPreferences);
    }
  }, [hasLoaded, initialPreferences]);

  function updatePreferences(type: keyof ContactPreferenceOptions) {
    setPreferences(preferences => {
      if (!preferences) return preferences;
      return { ...preferences, [type]: !preferences[type] };
    });
  }

  function getIsButtonDisabled() {
    if (!preferences) return true;
    return !Object.entries(preferences).some(([key, val]) =>
      initialPreferences
        ? initialPreferences[key as keyof ContactPreferenceOptions] !== val
        : true
    );
  }

  function getPreferencesDiffs(): Partial<ContactPreferences> {
    if (!preferences || !initialPreferences) return {};

    return Object.fromEntries(
      Object.entries(preferences).filter(
        ([key, value]) =>
          initialPreferences[key as keyof ContactPreferenceOptions] !== value
      )
    );
  }

  return {
    preferences,
    updatePreferences,
    getIsButtonDisabled,
    getPreferencesDiffs
  };
}
